import React from "react";
import { Link } from "react-router-dom";
import APSLogo from "../../../components/ui/APS Logo.svg";

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

const FooterSection = () => (
  <footer className="bg-white border-t border-surface-border py-12 px-6">
    <div className="max-w-6xl mx-auto grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-8">
      {/* Brand — full width on mobile */}
      <div className="col-span-2 sm:col-span-2 lg:col-span-1">
        <div className="flex items-center gap-2 mb-4">
          <img src={APSLogo} alt="APS Logo" className="h-11 w-auto object-contain" />
        </div>
        <p className="text-sm text-brand-muted leading-relaxed max-w-xs">
          Enterprise-grade AI privacy policy analysis for compliance teams worldwide.
        </p>
      </div>

      {/* Product */}
      <div>
        <h4 className="text-brand-text font-bold text-xs uppercase tracking-widest mb-4">Product</h4>
        <ul className="flex flex-col gap-2.5">
          <li><button type="button" onClick={() => scrollTo("how-it-works")} className="text-sm text-brand-muted hover:text-primary transition-colors text-left">How it Works</button></li>
          <li><button type="button" onClick={() => scrollTo("pricing")} className="text-sm text-brand-muted hover:text-primary transition-colors text-left">Pricing</button></li>
          <li><button type="button" onClick={() => scrollTo("testimonials")} className="text-sm text-brand-muted hover:text-primary transition-colors text-left">Testimonials</button></li>
        </ul>
      </div>

      {/* Company */}
      <div>
        <h4 className="text-brand-text font-bold text-xs uppercase tracking-widest mb-4">Company</h4>
        <ul className="flex flex-col gap-2.5">
          <li><Link to="/about" className="text-sm text-brand-muted hover:text-primary transition-colors">About</Link></li>
          {/* <li><Link to="/blog" className="text-sm text-brand-muted hover:text-primary transition-colors">Blog</Link></li> */}
        </ul>
      </div>

      {/* Legal */}
      <div>
        <h4 className="text-brand-text font-bold text-xs uppercase tracking-widest mb-4">Legal</h4>
        <ul className="flex flex-col gap-2.5">
          <li><Link to="/privacy-policy" className="text-sm text-brand-muted hover:text-primary transition-colors">Privacy Policy</Link></li>
          <li><Link to="/terms" className="text-sm text-brand-muted hover:text-primary transition-colors">Terms</Link></li>
        </ul>
      </div>
    </div>

    <div className="max-w-6xl mx-auto mt-10 pt-6 border-t border-surface-border flex flex-col sm:flex-row items-center justify-between text-xs text-brand-light gap-3">
      <span className="text-center sm:text-left">© 2026 AIPolicyScan. All rights reserved.</span>
      <div className="flex gap-4">
        {/* Twitter / X */}
        <a href="https://twitter.com" target="_blank" rel="noreferrer" className="hover:text-brand-text transition-colors">
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.402 6.231H2.745l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622Zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
          </svg>
        </a>
        {/* LinkedIn */}
        <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="hover:text-brand-text transition-colors">
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286ZM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065Zm1.782 13.019H3.555V9h3.564v11.452ZM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003Z" />
          </svg>
        </a>
        {/* GitHub */}
        <a href="https://github.com" target="_blank" rel="noreferrer" className="hover:text-brand-text transition-colors">
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
          </svg>
        </a>
      </div>
    </div>
  </footer>
);

export default FooterSection;
